import ACTION_TYPES from "./ActionTypes";
import { getWithExpiry } from "@/utils/token";
import { AppThunk } from "@/Store/index.ts";
export const BASE_URL = import.meta.env.VITE_API_URL;

const { USER, CAMPAIGN, MYPAGE, BANNER } = ACTION_TYPES;
const weuBeuaty = import.meta.env.VITE_APP_THEME
// 토큰 인증 실패 처리 함수
const handleAuthError = () => {
  localStorage.removeItem("token");
  window.location.href = "/login";
};

// API 호출 옵션 타입 정의
interface FetchApiOptions extends RequestInit {
  needAuth?: boolean;
  headers?: Record<string, string>;
}

// 공통 API 호출 함수
export const fetchApi = async (url: string, options: FetchApiOptions = {}) => {
  try {
    const token = getWithExpiry("token");
    // 토큰이 필요한 요청인데 토큰이 없는 경우
    if (options.needAuth && !token) {
      handleAuthError();
      throw new Error("인증 토큰이 없습니다.");
    }

    const headers = {
      "Content-Type": "application/json",
      ...(token && { Authorization: `${token}` }),
      ...options.headers,
    };

    if (options.body instanceof FormData) {
      delete headers["Content-Type"];
    }

    const response = await fetch(`${BASE_URL}${url}`, {
      ...options,
      headers,
    });

    // 인증 오류 처리 (401)
    if (response.status === 401) {
      handleAuthError();
      throw new Error("인증이 만료되었습니다. 다시 로그인해주세요.");
    }

    // 응답 실패 처리
    if (response.status === 401) {
      return handleAuthError();
    }

    return response;
  } catch (error) {
    console.error("API 호출 오류:", error);
    throw error;
  }
};

// upload image
export const upload =
  (file: File, location: string, width: number) => async (dispatch) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("location", location);
      if (width) {
        formData.append("width", width.toString());
      } else {
        formData.append("width", "300");
      }

      const response = await fetchApi(`/user/upload/profile`, {
        method: "PUT",
        needAuth: true,
        body: formData,
      });

      const data = await response!.json();

      if (!response!.ok) {
        throw new Error(
          `Upload failed: ${response!.status} - ${response!.statusText}`
        );
      }

      return data.data.path;
    } catch (error) {
      throw error; // Re-throw the error to handle it in the component
    }
  };

// LOGOUT ===========================================================================
export const logout = () => async () => {
  localStorage.removeItem("token");
  window.location.href = "/login";
};

// BANNER ===========================================================================
interface BannerData {
  id: number;
  imageUrl: string;
  title: string;
  link: string;
}
export const getAllBanner = (): Promise<BannerData[]> => async (dispatch) => {

  try {
    dispatch({ type: BANNER.GET_ALL_BANNER_START });

    let theme = weuBeuaty == "weubeauty" ? "beauty_web" : ""
    const response = await fetchApi(
      `/user/slot/banner?type=priority&size=5&lang=kr&key=${theme}`,
      {
        method: "GET",
      }
    );
    console.log(response);
    
    const data = await response!.json();

    console.log(data);
    
    dispatch({
      type: BANNER.GET_ALL_BANNER_SUCCESS,
      payload: data,
    });
    return data;
  } catch (error) {
    console.log("error get campaign");
    dispatch({
      type: BANNER.GET_ALL_BANNER_FAILED,
      payload: error,
    });
    throw error;
  }
};

// USER ===========================================================================
export const registerUser = (dataRegister) => async (dispatch) => {
  //  console.log(dataRegister)
  try {
    dispatch({ type: USER.POST_REGISTER_START });

    const response = await fetchApi(`/user`, {
      method: "POST",
      body: JSON.stringify(dataRegister),
    });

    const data = await response.json();

    if (response.status === 409) {
      return { meta: { code: 409, message: "user is exist" } };
    }

    if (!response.ok) {
      throw new Error(data.message || "Internal server error");
    }

    dispatch({
      type: USER.POST_REGISTER_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    dispatch({
      type: USER.POST_REGISTER_FAILED,
      payload: error.message,
    });

    throw error;
  }
};

export const loginUser = (dataLogin) => async (dispatch) => {
  try {
    dispatch({ type: USER.POST_LOGIN_START });

    const response = await fetchApi(`/user/login`, {
      method: "POST",
      body: JSON.stringify(dataLogin),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Internal server error");
    }

    const data = await response.json();

    dispatch({
      type: USER.POST_LOGIN_SUCCESS,
      payload: data,
    });

    // console.log(data)
    return data;
  } catch (error) {
    console.log("error login");
    dispatch({
      type: USER.POST_LOGIN_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const getDataUser = () => async (dispatch) => {
  try {
    dispatch({ type: USER.GET_USER_START });

    const response = await fetchApi(`/user?lang=0`, {
      method: "GET",
      needAuth: true,
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Internal server error");
    }
    const data = await response.json();
    dispatch({
      type: USER.GET_USER_SUCCES,
      payload: data,
    });
    return data;
  } catch (error) {
    console.log("error login");
    dispatch({
      type: USER.GET_USER_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

// CAMPAIGN ===========================================================================

interface CampaignFilter {
  type?: string;
  size?: number;
  page?: number;
  keyword?: string;
  campaign_type?: number[];
  ctg_id?: number;
  advertiser_id?: string | null; // "1,2,30" 같은 쉼표로 구분된 문자열
}

export const getPriortiyCampaign =
  (payload: CampaignFilter): AppThunk =>
  async (dispatch) => {
    const filter = {
      ...payload,
      keyword: payload.keyword || "", // Pastikan keyword tidak undefined
    };

    try {
      dispatch({ type: CAMPAIGN.GET_PRIORITY_CAMPAIGN_START });

      const params: any = {
        ...filter,
        campaign_type: filter.campaign_type.join(","),
        page: filter.page.toString(),
        size: filter.size.toString(),
      };
      
      // advertiser_id가 있으면 추가 (이미 쉼표로 구분된 문자열)
      if (filter.advertiser_id) {
        params.advertiser_id = filter.advertiser_id;
      }

      let theme = weuBeuaty == "weubeauty" ? "beauty" : "all"
      const response = await fetchApi(
        `/user/slot/campaign?${new URLSearchParams(params)}&category=${theme}`
      );

      const data = await response.json();

      dispatch({
        type: CAMPAIGN.GET_PRIORITY_CAMPAIGN_SUCCESS,
        payload: {
          data: data.data || [],
          totalRows: data.totalRows || 0,
        },
        meta: {
          replaceData: filter.page === 1,
        },
      });
    } catch (error) {
      dispatch({
        type: CAMPAIGN.GET_PRIORITY_CAMPAIGN_FAILED,
        payload: error.message,
      });
    }
  };

export const getIdCampaign = (id) => async (dispatch) => {
  // console.log("masuk id campaign >>>>>>");
  try {
    dispatch({ type: CAMPAIGN.GET_ID_CAMPAIGN_START });
    const response = await fetchApi(`/user/campaign?id=${id}`, {
      method: "GET",
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Internal server error");
    }
    const data = await response.json();
    dispatch({
      type: CAMPAIGN.GET_ID_CAMPAIGN_SUCCESS,
      payload: data,
    });
    return data;
  } catch (error) {
    console.log("error login");
    dispatch({
      type: CAMPAIGN.GET_ID_CAMPAIGN_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const getCategoryCampaign = () => async (dispatch) => {
  // console.log("masuk id campaign >>>>>>");
  try {
    dispatch({ type: CAMPAIGN.GET_CATEGORY_CAMPAIGN_START });
    const response = await fetchApi(`/campaign/category`, {
      method: "GET",
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Internal server error");
    }
    const data = await response.json();
    dispatch({
      type: CAMPAIGN.GET_CATEGORY_CAMPAIGN_SUCCESS,
      payload: data,
    });
    return data;
  } catch (error) {
    console.log("error login");
    dispatch({
      type: CAMPAIGN.GET_CATEGORY_CAMPAIGN_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const postRegisterCampaign = (dataRegister, isFamtour:boolean = false) => async (dispatch) => {
  console.debug(
    "🚀 ~ :388 ~ postRegisterCampaign ~ dataRegister:",
    dataRegister
  );
  try {
    dispatch({ type: CAMPAIGN.POST_FORM_CAMPAIGN_START });

    // console.log("📡 Sending data to API:", dataRegister);

    const url = isFamtour ? '/user/famtour/apply' : '/user/subscription'

    const response = await fetchApi(url, {
      method: "POST",
      needAuth: true,
      body: JSON.stringify(dataRegister),
    });

    const responseData = await response.json();
    // console.log("✅ API Response:", responseData);

    // Handling berbagai kondisi error
    if (
      response.status === 401 ||
      responseData?.meta?.message?.toLowerCase().includes("token is expired") ||
      responseData?.meta?.message
        ?.toLowerCase()
        .includes("token signature is invalid")
    ) {
      console.error("🚨 Token error detected, throwing 'session_expired'");
      localStorage.removeItem("token");
      throw new Error("session_expired");
    }

    if (
      response.status === 503 ||
      responseData?.meta?.message?.toLowerCase().includes("already subscribe") ||
      responseData?.meta?.message?.toLowerCase().includes("already applied") // Famtour error
    ) {
      console.error("🚨 Already subscribed, throwing 'already_subscribe'");
      throw new Error("already_subscribe");
    }

    if (
      response.meta?.code === 506 ||
      responseData?.meta?.message?.toLowerCase().includes("not in period")
    ) {
      console.error("🚨 Not in period, throwing 'not_in_period'");
      throw new Error("not_in_period");
    }

    if (
      !response.ok ||
      response.meta?.code === 500 ||
      responseData?.meta?.message
        ?.toLowerCase()
        .includes("internal server error")
    ) {
      console.error(
        "🚨 Internal server error detected, throwing general error"
      );
      throw new Error(responseData.meta?.message || "Internal server error");
    }

    // console.log("✅ Data berhasil dikirim:", responseData.data);

    dispatch({
      type: CAMPAIGN.POST_FORM_CAMPAIGN_SUCCESS,
      payload: responseData,
    });

    return responseData;
  } catch (error) {
    console.error("❌ Error inside postRegisterCampaign:", error.message); // Debugging error
    dispatch({
      type: CAMPAIGN.POST_FORM_CAMPAIGN_FAILED,
      payload: error.message,
    });

    throw error; // Lempar error agar ditangkap di handleSubmit
  }
};

// MYPAGE ===========================================================================
export const getAllExperience = () => async (dispatch) => {
  try {
    dispatch({ type: MYPAGE.GET_EXPERIENCE_START });
    let theme = weuBeuaty == "weubeauty" ? "beauty" : "all" 
    const response = await fetchApi(`/user/subscription/list?status=view&category=${theme}`, {
      method: "GET",
      needAuth: true,
    });

    const data = await response!.json();

    dispatch({
      type: MYPAGE.GET_EXPERIENCE_SUCCESS,
      payload: data,
    });

    return data;
  } catch (error) {
    console.log("Error get experience:", error.message);
    dispatch({
      type: MYPAGE.GET_EXPERIENCE_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const cancelExperience = (dataCancel: any, isFamtour?: boolean) => async (dispatch) => {
  try {
    dispatch({ type: MYPAGE.PUT_CANCEL_CAMPAIGN_START });

    const url = isFamtour ? '/user/famtour/canceled' : '/user/subscription/canceled';

    const response = await fetchApi(url, {
      method: isFamtour ? 'POST' : 'PUT',
      needAuth: true,
      body: JSON.stringify(dataCancel),
    });

    const data = await response.json(); // Ambil respons JSON lebih awal

    if (!response.ok) {
      throw new Error(data.message || "Internal server error");
    }


    dispatch({
      type: MYPAGE.PUT_CANCEL_CAMPAIGN_SUCCESS,
      payload: data,
    });

    return { success: true, data }; // ✅ Pastikan return sukses
  } catch (error) {
    console.error("Cancel Error:", error.message);

    dispatch({
      type: MYPAGE.PUT_CANCEL_CAMPAIGN_FAILED,
      payload: error.message,
    });

    return { success: false, error: error.message }; // ✅ Pastikan return gagal
  }
};

export const getAllInvitation = () => async (dispatch) => {
  try {
    dispatch({ type: MYPAGE.GET_INVITATION_START });

    const response = await fetchApi(`/user/subscription/list?status=selected&category="beauty"`, {
      method: "GET",
      needAuth: true,
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Internal server error");
    }
    const data = await response.json();

    dispatch({
      type: MYPAGE.GET_INVITATION_SUCCESS,
      payload: data,
    });
    return data;
  } catch (error) {
    console.log("Error get INVITATION:", error.message);
    dispatch({
      type: MYPAGE.GET_INVITATION_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const getAllInvitationAttend = () => async (dispatch) => {
  try {
    dispatch({ type: MYPAGE.GET_INVITATION_ATTEND_START });
    let theme = weuBeuaty == "weubeauty" ? "beauty" : "all" 
    const response = await fetchApi(`/user/subscription/list?status=attend&category=${theme}`, {
      method: "GET",
      needAuth: true,
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Internal server error");
    }
    const data = await response.json();

    dispatch({
      type: MYPAGE.GET_INVITATION_ATTEND_SUCCESS,
      payload: data,
    });
    return data;
  } catch (error) {
    console.log("Error get INVITATION:", error.message);
    dispatch({
      type: MYPAGE.GET_INVITATION_ATTEND_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const patchAttendInvitation = (dataAttend) => async (dispatch) => {
  // console.log("masuk attend patch");
  try {
    dispatch({ type: MYPAGE.PATCH_ATTEND_INVITATION_START });

    const response = await fetchApi(`/user/attended`, {
      method: "PATCH",
      needAuth: true,
      body: JSON.stringify(dataAttend),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Internal server error");
    }
    const data = await response.json();
    dispatch({
      type: MYPAGE.PATCH_ATTEND_INVITATION_SUCCESS,
      payload: data,
    });
    // console.log("data", data);
    return data;
  } catch (error) {
    console.log("Error patch attend INVITATION:", error.message);
    dispatch({
      type: MYPAGE.PATCH_ATTEND_INVITATION_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const postFormReview = (dataFormReview) => async (dispatch) => {
  // console.log("dataFormRev", dataFormReview);
  try {
    dispatch({ type: MYPAGE.POST_REVIEW_FORM_START });

    const response = await fetchApi(`/user/review`, {
      method: "PUT",
      needAuth: true,
      body: JSON.stringify(dataFormReview),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Internal server error"); // Lempar error dengan pesan dari API
    }

    const data = await response.json();

    dispatch({
      type: MYPAGE.POST_REVIEW_FORM_SUCCESS,
      payload: data,
    });
    // console.log(data );
    return data;
  } catch (error) {
    // console.log("error REVIEW FORM");
    dispatch({
      type: MYPAGE.POST_REVIEW_FORM_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const postImageTracker = (dataImageTracker) => async (dispatch) => {
  // console.log("dataFormRev", dataImageTracker);
  try {
    dispatch({ type: MYPAGE.POST_IMAGE_TRACKER_START });

    const response = await fetchApi(`/user/generate/url_tracking`, {
      method: "POST",
      needAuth: true,
      body: JSON.stringify(dataImageTracker),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Internal server error"); // Lempar error dengan pesan dari API
    }

    const data = await response.json();

    dispatch({
      type: MYPAGE.POST_IMAGE_TRACKER_SUCCESS,
      payload: data.data,
    });
    // console.log(data.data, "Image Tracker Data");
    return data;
  } catch (error) {
    console.log(error, "error");
    dispatch({
      type: MYPAGE.POST_IMAGE_TRACKER_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const getAllReview = () => async (dispatch) => {
  // console.log("masuk review");
  try {
    dispatch({ type: MYPAGE.GET_REVIEW_START });

    const response = await fetchApi(`/user/review/list`, {
      method: "GET",
      needAuth: true,
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Internal server error");
    }
    const data = await response.json();
    dispatch({
      type: MYPAGE.GET_REVIEW_SUCCESS,
      payload: data,
    });
    // console.log("data", data);
    return data;
  } catch (error) {
    console.log("Error get INVITATION:", error.message);
    dispatch({
      type: MYPAGE.GET_REVIEW_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

interface ProfileData {
  name: string;
  nick_name: string;
  phone: string;
  blog_url?: string;
  user_id?: number;
}

export const putChangeProfile =
  (changeProfile: ProfileData) => async (dispatch: any) => {
    // console.log("🚀 Data to be sent:", changeProfile);
    try {
      dispatch({ type: MYPAGE.PUT_PROFILE_START });

      // console.log("🔑 Token:", token);

      const response = await fetchApi(`/user/profile`, {
        method: "PUT",
        needAuth: true,
        body: JSON.stringify(changeProfile),
      });

      // console.log("📡 Response status:", response.status);

      let data;
      try {
        data = await response.json();
      } catch (jsonError) {
        console.error("❌ Error parsing JSON:", jsonError);
        throw new Error("Invalid response format");
      }

      if (!response.ok) {
        console.error("⚠️ Server Error:", data.meta.message);
        throw new Error(data.message || "Internal server error");
      }

      dispatch({
        type: MYPAGE.PUT_PROFILE_SUCCESS,
        payload: data,
      });

      // console.log("✅ Success Response:", data.data);
      return data;
    } catch (error) {
      console.error("🔥 Request Failed:", error.message);

      dispatch({
        type: MYPAGE.PUT_PROFILE_FAILED,
        payload: error.message,
      });

      throw error;
    }
  };

export const putChangePassword = (changePassword) => async (dispatch) => {
  // console.log("dataFormRev", changePassword);
  try {
    dispatch({ type: MYPAGE.PUT_PASSWORD_START });

    const response = await fetchApi(`/user/change-password`, {
      method: "PUT",
      needAuth: true,
      body: JSON.stringify(changePassword),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Internal server error");
    }

    const data = await response.json();

    dispatch({
      type: MYPAGE.PUT_PASSWORD_SUCCESS,
      payload: data,
    });
    // console.log(data );
    return data;
  } catch (error) {
    // console.log(error, "error");
    dispatch({
      type: MYPAGE.PUT_PASSWORD_FAILED,
      payload: error.message,
    });
    throw error;
  }
};

export const getEmailValidation = (emailValidation) => async (dispatch) => {
  try {
    const encodedEmail = encodeURIComponent(emailValidation);

    const response = await fetchApi(
      `/user/email-validation?email=${encodedEmail}`,
      {
        method: "GET",
      }
    );

    // Parsing JSON hanya jika response bukan No Content (204)
    let data = null;
    if (response.status !== 204) {
      data = await response.json();
    }

    // Handle kasus 400 (email sudah ada)
    if (response.status === 400) {
      throw new Error(data?.meta?.message || "email already exists");
    }

    // Jika request sukses
    if (response.ok) {
      dispatch({
        type: USER.GET_EMAIL_VALIDATION_SUCCESS,
        payload: data,
      });
      return data;
    }

    // Jika ada status error lain
    throw new Error(data?.meta || "Internal server error");
  } catch (error) {
    dispatch({
      type: USER.GET_EMAIL_VALIDATION_FAILED,
      payload: error.message,
    });
    throw error;
  }
};
